import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const REQUEST = 'HUB_REQUEST';
export const SUCCESS = 'HUB_SUCCESS';
export const FAILURE = 'HUB_FAILURE';

const initialState = {
  loaded: false,
};

export default function hubReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(
        {},
        {
          error: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    default:
      return state;
  }
}

export function fetchHubRequest(data) {
  return { type: REQUEST, data };
}

export function fetchHubSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchHubFailure(data) {
  return { type: FAILURE, data };
}

export function fetchHubAction() {
  return function (dispatch, getState, { Api, i18n }) {
    dispatch(fetchHubRequest());

    const {
      pageConfig: { previewMode, tenantId },
    } = getState();

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchHub({ tenantId })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchHubSuccess(response));
        } else {
          return dispatch(fetchHubFailure(response));
        }
      });
  };
}
